import alfalfa from './alfalfa.svg?react';
import almonds from './almonds.svg?react';
import apples from './apples.svg?react';
import apricots from './apricots.svg?react';
import artichokeGlobe from './artichokeGlobe.svg?react';
import artichokeJarusalem from './artichokeJarusalem.svg?react';
import asparagus from './asparagus.svg?react';
import aubergines from './aubergines.svg?react';
import barley from './barley.svg?react';
import beetroot from './beetroot.svg?react';
import berries from './berries.svg?react';
import blackberries from './blackberries.svg?react';
import borecole from './borecole.svg?react';
import brassicaVeg from './brassicaVeg.svg?react';
import broadbeans from './broadbeans.svg?react';
import broccoli from './broccoli.svg?react';
import brusselSprouts from './brusselSprouts.svg?react';
import cabbage from './cabbage.svg?react';
import canola from './canola.svg?react';
import carrots from './carrots.svg?react';
import cauliflower from './cauliflower.svg?react';
import celeriac from './celeriac.svg?react';
import celery from './celery.svg?react';
import chamomileHerb from './chamomileHerb.svg?react';
import cherries from './cherries.svg?react';
import chickpeas from './chickpeas.svg?react';
import chillies from './chillies.svg?react';
import chives from './chives.svg?react';
import citrus from './citrus.svg?react';
import clover from './clover.svg?react';
import coffee from './coffee.svg?react';
import coriander from './coriander.svg?react';
import corn from './corn.svg?react';
import cotton from './cotton.svg?react';
import courgettes from './courgettes.svg?react';
import cucumber from './cucumber.svg?react';
import curcubits from './curcubits.svg?react';
import dillLeaf from './dillLeaf.svg?react';
import driedPeas from './driedPeas.svg?react';
import dryBeans from './dryBeans.svg?react';
import endive from './endive.svg?react';
import fallow from './fallow.svg?react';
import fieldBeans from './fieldBeans.svg?react';
import fodderBeet from './fodderBeet.svg?react';
import forageCorn from './forageCorn.svg?react';
import frenchDwarfBeans from './frenchDwarfBeans.svg?react';
import fruitingVeg from './fruitingVeg.svg?react';
import garlic from './garlic.svg?react';
import gooseberries from './gooseberries.svg?react';
import grapes from './grapes.svg?react';
import grassesPasture from './grassesPasture.svg?react';
import grassesSeed from './grassesSeed.svg?react';
import greenSnapBeans from './greenSnapBeans.svg?react';
import hazelnuts from './hazelnuts.svg?react';
import hemp from './hemp.svg?react';
import hops from './hops.svg?react';
import leafyVeg from './leafyVeg.svg?react';
import leeks from './leeks.svg?react';
import legumeVeg from './legumeVeg.svg?react';
import lettuces from './lettuces.svg?react';
import linseed from './linseed.svg?react';
import loganberries from './loganberries.svg?react';
import lucerne from './lucerne.svg?react';
import lupine from './lupine.svg?react';
import melons from './melons.svg?react';
import millet from './millet.svg?react';
import mulberry from './mulberry.svg?react';
import mushrooms from './mushrooms.svg?react';
import mustardRed from './mustardRed.svg?react';
import navyBeans from './navyBeans.svg?react';
import oats from './oats.svg?react';
import oilseedRape from './oilseedRape.svg?react';
import onions from './onions.svg?react';
import onionsSalad from './onionsSalad.svg?react';
import parsnips from './parsnips.svg?react';
import peanuts from './peanuts.svg?react';
import pears from './pears.svg?react';
import peas from './peas.svg?react';
import pecans from './pecans.svg?react';
import peppers from './peppers.svg?react';
import pistachios from './pistachios.svg?react';
import plums from './plums.svg?react';
import pomeFruits from './pomeFruits.svg?react';
import potato from './potato.svg?react';
import potatoes from './potatoes.svg?react';
import pulse from './pulse.svg?react';
import pumpkins from './pumpkins.svg?react';
import quinces from './quinces.svg?react';
import radicchio from './radicchio.svg?react';
import raspberries from './raspberries.svg?react';
import redcurrents from './redcurrents.svg?react';
import rhubarb from './rhubarb.svg?react';
import rice from './rice.svg?react';
import runnerBeans from './runnerBeans.svg?react';
import rye from './rye.svg?react';
import ryeGrass from './ryeGrass.svg?react';
import scarole from './scarole.svg?react';
import shallots from './shallots.svg?react';
import sorghum from './sorghum.svg?react';
import soybeans from './soybeans.svg?react';
import spinach from './spinach.svg?react';
import squash from './squash.svg?react';
import stoneFruit from './stoneFruit.svg?react';
import strawberries from './strawberries.svg?react';
import sugarBeet from './sugarBeet.svg?react';
import sugarcane from './sugarcane.svg?react';
import sunflower from './sunflower.svg?react';
import swede from './swede.svg?react';
import sweetPotato from './sweetPotato.svg?react';
import tobacco from './tobacco.svg?react';
import tomatoes from './tomatoes.svg?react';
import treeFruit from './treeFruit.svg?react';
import treeNuts from './treeNuts.svg?react';
import triticale from './triticale.svg?react';
import turnips from './turnips.svg?react';
import vegetables from './vegetables.svg?react';
import vetch from './vetch.svg?react';
import walnuts from './walnuts.svg?react';
import watermelon from './watermelon.svg?react';
import wheat from './wheat.svg?react';

export const CropIcons = {
  alfalfa,
  almonds,
  apples,
  apricots,
  artichokeGlobe,
  artichokeJarusalem,
  asparagus,
  aubergines,
  barley,
  beetroot,
  berries,
  blackberries,
  borecole,
  brassicaVeg,
  broadbeans,
  broccoli,
  brusselSprouts,
  cabbage,
  canola,
  carrots,
  cauliflower,
  celeriac,
  celery,
  chamomileHerb,
  cherries,
  chickpeas,
  chillies,
  chives,
  citrus,
  clover,
  coffee,
  coriander,
  corn,
  cotton,
  courgettes,
  cucumber,
  curcubits,
  dillLeaf,
  driedPeas,
  dryBeans,
  endive,
  fallow,
  fieldBeans,
  fodderBeet,
  forageCorn,
  frenchDwarfBeans,
  fruitingVeg,
  garlic,
  gooseberries,
  grapes,
  grassesPasture,
  grassesSeed,
  greenSnapBeans,
  hazelnuts,
  hemp,
  hops,
  leafyVeg,
  leeks,
  legumeVeg,
  lettuces,
  linseed,
  loganberries,
  lucerne,
  lupine,
  melons,
  millet,
  mulberry,
  mushrooms,
  mustardRed,
  navyBeans,
  oats,
  oilseedRape,
  onionsSalad,
  onions,
  parsnips,
  peanuts,
  pears,
  peas,
  pecans,
  peppers,
  pistachios,
  plums,
  pomeFruits,
  potato,
  potatoes,
  pulse,
  pumpkins,
  quinces,
  radicchio,
  raspberries,
  redcurrents,
  rhubarb,
  rice,
  runnerBeans,
  ryeGrass,
  rye,
  scarole,
  shallots,
  sorghum,
  soybeans,
  soybean: soybeans,
  spinach,
  squash,
  stoneFruit,
  strawberries,
  sugarBeet,
  sugarcane,
  sunflower,
  swede,
  sweetPotato,
  tobacco,
  tomatoes,
  treeFruit,
  treeNuts,
  triticale,
  turnips,
  vegetables,
  vetch,
  walnuts,
  watermelon,
  wheat,
};

const KEYS_BY_NORMALIZED = new Map(Object.keys(CropIcons).map((key) => [key.toLowerCase(), key]));

/** Keys are camelCase, so "Sugar Beet" only resolves once both sides are stripped to letters. */
export function resolveCropIconKey(candidate: string): string | undefined {
  return KEYS_BY_NORMALIZED.get(candidate.replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
}

/** CropIcon silently falls back to `barley`, so resolve against CropIcons before it ships. */
export function toCropIconKey(cropId: string, cropName: string): string {
  const candidates = [cropName, cropName.replace(/s$/, ''), cropId.replace(/-\d+$/, '')];

  for (const candidate of candidates) {
    const key = resolveCropIconKey(candidate);
    if (key) return key;
  }

  return cropName.toLowerCase();
}
